// 负责处理与额度相关的api
import ApiBase from './api_base'
import lodash from 'lodash'

export default class QuotaApi {
  static index(params) {
    return ApiBase.get(params.organization_id ? `/organizations/${params.organization_id}/quotas` : '/quotas')
  }

  static buy(params) {
    return ApiBase.post(params.organization_id ? `/organizations/${params.organization_id}/quotas` : '/quotas', lodash.pick(params, ['package', 'project_id', 'promote_code', 'payment_method', 'return_path']))
  }

  // 使用额度
  static consume(params) {
    return ApiBase.post('/quotas/consume', lodash.pick(params, ['key', 'project_id']))
  }

  // 查询价格
  static price(params) {
    return ApiBase.get('/quotas/new', lodash.pick(params, ['package', 'promote_code']))
  }
}



// WEBPACK FOOTER //
// ./src/api/quota.js